<template>
  <span class="m-k__s">
      <a target="_blank" :href="ozonHref()">🔵</a>
      <a target="_blank" :href="mmHref()">🟢</a>
      <a target="_blank" :href="yandexHref()">🟡</a>
      <a target="_blank" :href="wbHref()">🟣</a>
  </span>
</template>

<script>
export default {
  name: "TheSearchPanel",
  props: ['query'],
  methods: {
    ozonHref() {
      return 'https://www.ozon.ru/search/?from_global=true&text=' + encodeURIComponent(this.query);
    },
    mmHref() {
      return 'https://megamarket.ru/catalog/?q=' + encodeURIComponent(this.query);
    },
    yandexHref() {
      return 'https://market.yandex.ru/search-redirect?cvredirect=1&text=' + encodeURIComponent(this.query);
    },
    wbHref() {
      return 'https://www.wildberries.ru/catalog/0/search.aspx?search=' + encodeURIComponent(this.query);
    }
  }
}
</script>